<template>
  <div id="home" class="stage home-stage">
    <header class="home inert-while-dialog-open"  role="banner">
      <div
        aria-hidden="true"
        class="bg"
        :style="
          pics.headerPicDefault
            ? `background-image: url(${pics.headerPicDefault})`
            : 'background-image: url(/assets/images/header.jpg)'
        "
      ></div>
    </header>
    <div class="main inert-while-dialog-open home dark-curved-bg" role="main" aria-labelledby="header-headline" aria-describedby="header-subline">
      <img class="plastikfrei-stoerer" src="/assets/images/plastikfrei-stoerer.png" alt="Bild mit Text: 100% Plastikfrei: 100% Papier (Raketenmantel, Treibermantel, Abdeckkappe) -100% Holz (Leitstab)" />
      <section class="home-header">
        <h1 id="header-headline" class="desktop">{{ $l("headerHeadlineDesktop") }}</h1>
        <h1 id="header-headline" class="mobile">{{ $l("headerHeadlineMobile") }}</h1>
        <small id="header-subline" class="desktop">{{ $l("headerSublineDesktop") }}</small>
        <small id="header-subline" class="mobile">{{ $l("headerSublineMobile") }}</small>
        <HowTo />
      </section>
      <section class="home-market-selection">
        <div class="copy desktop">
          <h2>{{ $l("marktfilterungHeadlineDesktop") }}</h2>
          <p>
            {{ $l("marktfilterungSublineDesktop") }}
          </p>
        </div>
        <div class="copy mobile">
          <h2>{{ $l("marktfilterungHeadlineMobile") }}</h2>
          <p>
            {{ $l("marktfilterungSublineMobile") }}
          </p>
        </div>
        <div class="selector">
          <HomeMarketSelect
            @showMarketSearchMobile="showMarketSearchMobile = true"
            @showMarketSearchResults="showMarketSearchResults = true"
          />
        </div>
      </section>
      <section class="home-product-list" ref="productslistContainer">
        <div class="head">
          <h2>
            Unser Feuerwerkssortiment<sup><a tabindex="19" href="#fn1" id="fn1-link" aria-label="Fußnoten anzeigen" aria-describedby="footnote-label">*</a></sup>
            <div class="no-market-hint" v-if="products && products.length > 0">
              Verkauf nur solange der Vorrat reicht.
            </div>
          </h2>
          <img class="weco" src="/assets/images/weco-logo.png" alt="WECO feuerwerk Logo" />
          <button class="button-light" v-on:click.prevent="toggleFilter" 
                  :aria-expanded="showFilter" 
                  aria-controls="filter-overlay"
                  :aria-label="`${filters && filters.length > 0 ? `${filters.length} Filter aktiv` : 'Produkte filtern'}`"
                  tabindex="20"
            >
            <span v-if="filters && filters.length > 0">
              <em>{{ filters.length }}</em> Filter aktiv
            </span>
            <span v-else>Produkte filtern</span>
          </button>
        </div>
        <ProductsList ref="productslist" />
      </section>
    </div>

    <MarketSearchResults
      v-if="showMarketSearchResults"
      @close="showMarketSearchResults = false"
    />

    <MarketSearchMobile
      v-if="showMarketSearchMobile"
      @close="showMarketSearchMobile = false"
      @showMarketSearchResults="
        showMarketSearchMobile = false;
        showMarketSearchResults = true;
      "
    />

    <HomeOutro />

    <FooterComponent />

    <FiltersComponent v-if="showFilter" 
                      @close="hideFilterOverlay" 
                      id="filter-overlay"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Produktfilter" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import HowTo from "@/components/HowTo";
import HomeMarketSelect from "@/components/HomeMarketSelect";
import FiltersComponent from "@/components/Filter";
import ProductsList from "@/components/ProductsList";
import MarketSearchResults from "@/components/MarketSearchResults";
import MarketSearchMobile from "@/components/MarketSearchMobile";
import HomeOutro from "@/components/HomeOutro";
import FooterComponent from "@/components/Footer";
import throttle from "lodash.throttle";
export default {
  name: "home",
  components: {
    HowTo,
    HomeMarketSelect,
    FiltersComponent,
    ProductsList,
    MarketSearchResults,
    MarketSearchMobile,
    HomeOutro,
    FooterComponent
  },
  data() {
    return {
      showFilter: false,
      showMarketSearchResults: false,
      showMarketSearchMobile: false
    };
  },
  created() {
    window.addEventListener("scroll", this.onPageScroll);
  },
  mounted: async function() {
    // load products
    if (this.$route.params.jump) {
      window.setTimeout(() => {
        window.scrollTo(0, this.homeScrollPosition);
      }, 10);
    }
    this.$trackPageView({ name: ":startseite", hierarchy: [] });
    
    await this.$store.dispatch("getProducts", this.$route.params.nr || false);
    this.$store.dispatch("updateShoppinglistData");
    this.$emit("setSharelist", false);

    
  },
  methods: {
    hideFilterOverlay() {
      this.showFilter = false;
      window.setTimeout(() => {
        const boundingRect = this.$refs.productslistContainer.getBoundingClientRect();
        window.scrollTo(0, boundingRect.top - 100);
      }, 10);
    },
    onPageScroll: throttle(function() {
      if (this.$route.meta.type === "home") {
        this.$store.commit("SET_HOMESCROLLPOSITION", window.pageYOffset);
      }
    }, 300),
    toggleFilter() {
      this.showFilter = !this.showFilter;
    }
  },
  watch: {
    showMarketSearchResults(newVal) {
      this.$store.commit("SET_BODY_NO_OVERFLOW", newVal);
      this.$store.commit("SET_DIALOG_OPEN", newVal);
    },
    showMarketSearchMobile(newVal) {
      this.$store.commit("SET_BODY_NO_OVERFLOW", newVal);
      this.$store.commit("SET_DIALOG_OPEN", newVal);
    },
    showFilter(newVal) {
      this.$store.commit("SET_BODY_NO_OVERFLOW", newVal);
      this.$store.commit("SET_DIALOG_OPEN", newVal);
    },
    jumpToList(newVal) {
      if (newVal === true) {
        this.$SmoothScroll(this.$refs.productslistContainer, 1000);
        this.$store.commit("SET_JUMPTOLIST", false);
      }
    }
  },
  computed: {
    ...mapState([
      "loading",
      "market",
      "filters",
      "jumpToList",
      "homeScrollPosition",
      "pics",
      "dialogOpen"
    ]),
    ...mapGetters(["products", "isMobile"])
  }
};
</script>

<style lang="scss">
@import "Home.scss";
</style>
